<template>
  <section id="mainContainer">
    <userHeader></userHeader>
    <section class="mid-container">
      <section class="blog-detail-section">
        <div class="container">
          <div class="blog-detail-inner" :class="{ 'full-blog-details': allRelatedBlogs.length == 0 }">
            <div class="blog-detail-content">
              <div class="white__bg">
                <div class="blog-image-slider">
                  <div class="blog-image-item">
                    <img :src="getCdnImageAddress(blogData.blogImage, `w_1200,h_627/`)" width="100%" alt="" />
                  </div>
                </div>
                <h1>{{ blogData.title }}</h1>
                <div class="blog-auther-date">
            <ul>
              <li><i><img src="@/assets/images/user.svg" alt="" /></i>{{ blogData.author }}</li>
              <li><i><img src="@/assets/images/calendar-alt.svg" alt="" /></i>{{ formattedDate }}</li>
              <li class="social-sharing-icons" >
                <ul>
                  <li>
                    <a :href="facebookShareUrl" class="facebook" target="_blank" rel="noopener">
                      <i><img src="@/assets/images/social-sharing-icon/facebook-sharing-icon.svg" alt="" /></i>
                    </a>
                  </li>
                  <li>
                    <a :href="twitterShareUrl" class="twitter" target="_blank" rel="noopener">
                      <i><img src="@/assets/images/social-sharing-icon/twitter-sharing-icon.svg" alt="" /></i>
                    </a>
                  </li>
                  <li>
                    <a :href="linkedinShareUrl" class="linkedin" target="_blank" rel="noopener">
                      <i><img src="@/assets/images/social-sharing-icon/linkedin-sharing-icon.svg" alt="" /></i>
                    </a>
                  </li>
                  <li>
                    <a :href="pinterestShareUrl" class="pinterest" target="_blank" rel="noopener">
                      <i><img src="@/assets/images/social-sharing-icon/pinterest-sharing-icon.svg" alt="" /></i>
                    </a>
                  </li>
                </ul>
              </li>

            </ul>
          </div>
                <div class="blog-content">
                  <p v-html="blogData.description"></p>
                </div>
              </div>
              <div class="next-pre-blog clearfix">
                <ul>
                  <li class="previous-blog">
                    <a @click.prevent="previousBlog" href="#" :class="{ disabled: !hasPreviousBlog }">
                      <i></i> Previous Blog
                    </a>
                  </li>
                  <li class="next-blog">
                    <a @click.prevent="nextBlog" href="#" :class="{ disabled: !hasNextBlog }">
                      Next Blog <i></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div class="blog-detail-sidebar" v-if="allRelatedBlogs.length > 0">
              <div class="related-post" >
                <h3>Related Posts</h3>
                <div class="related-post-list">
                  <div class="related-post-row clearfix" v-for="relatedBlog in allRelatedBlogs.slice(0, 4)" :key="relatedBlog.id">
                    <div class="related-post--img">
                      <img :src="getCdnImageAddress(relatedBlog.blogImage, `w_90,h_57/`)" alt="" />
                    </div>
                    <div class="related-post--content">
                      <router-link :to="`/blogs/${relatedBlog.slug}`">{{ relatedBlog.title }}</router-link>
                    </div>
                  </div>
                </div>
              </div>
              <!-- <div class="sidebar-btn-set mt-15">
                <button class="primary-btn-outline" data-bs-toggle="modal" data-bs-target="#joinUs">Join Us</button>
              </div> -->
            </div>
            <div class="clear"></div>
          </div>
        </div>
      </section>
    </section>
    <jobForm></jobForm>
    <userFooter></userFooter>
    <ChatbotPopup></ChatbotPopup>
  </section>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import userHeader from "@/components/userHeader.vue";
import axios from 'axios';
import { useRoute } from 'vue-router';
import userFooter from "@/components/userFooter.vue";
import jobForm from "@/components/jobForm.vue";
import { environment } from '@/config/environment';
import { API_BASE_URL } from '@/config/api.config';
import ChatbotPopup from '@/components/chatbotPopup.vue';

export default defineComponent({
  name: "readMoreBlogs",
  components: {
    userHeader,
    userFooter,
    jobForm,
    ChatbotPopup
  },
  props: {
  blogUrl: {
  type: String,
  required: true
  },
  blogTitle: {
  type: String,
  default: ''
  },
  blogImage: {
  type: String,
  default: ''
  }
},
  data() {
    return {
      blog_url: window.location.href,
      blogSlug: '',
      blogData: {
        id: 0,
        title: '',
        author: '',
        blogCategory: '',
        location: '',
        blogPostDate: '',
        description: '',
        blogImage: '',
        Updated_at: '',
        Created_at: '',
        slug: '',
        position: 0
      },
      allRelatedBlogs: [] as any[],
      allBlogs: [] as any[],
      currentBlogIndex: -1
    };
  },
  computed: {

  facebookShareUrl() {
return `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(this.blog_url)}`;
},
twitterShareUrl() {
return `https://twitter.com/intent/tweet?url=${encodeURIComponent(this.blog_url)}&text=${encodeURIComponent(this.blogData.title)}`;
},
linkedinShareUrl() {
return `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(this.blog_url)}`;
},
pinterestShareUrl() {
return `https://pinterest.com/pin/create/button/?url=${encodeURIComponent(this.blog_url)}&media=${encodeURIComponent(this.blogData.blogImage)}&description=${encodeURIComponent(this.blogData.title)}`;
},
  
    truncatedDescription(): string {
      return this.blogData.description.length > 100
        ? this.blogData.description.substring(0, 100) + '...'
        : this.blogData.description;
    },
    formattedDate(): string {
      if (!this.blogData.blogPostDate) return '';
      // console.log(this.blogData.created_at)
      const date = new Date(this.blogData.blogPostDate);
      const parts = new Intl.DateTimeFormat('en-GB', {
        day: '2-digit',
        month: 'long',
        year: 'numeric',
      }).formatToParts(date);
      return `${parts[0].value} ${parts[2].value}, ${parts[4].value}`;
    },
    hasPreviousBlog(): boolean {
      return this.currentBlogIndex > 0;
    },
    hasNextBlog(): boolean {
      return this.currentBlogIndex < this.allBlogs.length - 1;
    }
  },
  methods: {
    async fetchBlogData() {
      try {
        const blogSlug = this.blogSlug;
        // Fetch current blog by slug
        const blogResponse = await axios.get(`${API_BASE_URL}/blog/${blogSlug}/`);
        this.blogData = blogResponse.data;
        console.log(this.blogData);

        // Fetch related blogs by category
        const blogsResponse = await axios.get(`${API_BASE_URL}/blog/`, {
          params: {
            status: 1,
            blogCategory: this.blogData.blogCategory
          }
        });
        this.allRelatedBlogs = blogsResponse.data.filter((blog: { id: number }) => blog.id !== this.blogData.id);

        // Fetch all published blogs, sorted by -position
        const allBlogsResponse = await axios.get(`${API_BASE_URL}/blog/`, {
          params: {
            status: 1,
            ordering: '-position' // Ensure API sorts by -position
          }
        });
        this.allBlogs = allBlogsResponse.data;
        this.currentBlogIndex = this.allBlogs.findIndex((blog: { slug: string }) => blog.slug === this.blogSlug);
      } catch (err) {
        console.error('Error fetching blog data:', err);
      }
    },
    navigateToBlog(slug: string) {
      this.$router.push(`/blogs/${slug}`);
    },
    nextBlog() {
      if (!this.hasNextBlog) return;
      this.currentBlogIndex += 1;
      const nextBlogSlug = this.allBlogs[this.currentBlogIndex].slug;
      this.navigateToBlog(nextBlogSlug);
    },
    previousBlog() {
      if (!this.hasPreviousBlog) return;
      this.currentBlogIndex -= 1;
      const prevBlogSlug = this.allBlogs[this.currentBlogIndex].slug;
      this.navigateToBlog(prevBlogSlug);
    },
    getCdnImageAddress(src: string, size: string): string {
      if (!src) return '';
      let cdnUrl: string = environment.imageCdn.getHost;
      cdnUrl = cdnUrl.concat(size);
      return cdnUrl + encodeURIComponent(src);
    }
  },
  mounted() {
    const route = useRoute();
    this.blogSlug = route.params.slug as string;
    if (this.blogSlug) {
      this.fetchBlogData();
    } else {
      console.error('No slug provided in route');
    }
  },
  watch: {
    '$route.params.slug'(newSlug: string) {
      this.blogSlug = newSlug;
      this.fetchBlogData();
    }
  }
});
</script>

<!-- <style scoped>
.next-pre-blog ul {
  display: flex;
  justify-content: space-between;
}
.next-pre-blog a {
  cursor: pointer;
}
.next-pre-blog a.disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
</style> -->

<style  scoped>
.full-blog-details{
  .blog-detail-content{
    width: 100%;
  }
}
.blog-auther-date ul{
  @media screen and (max-width: 767px){
    flex-wrap: wrap;
    
  }
}
.blog-auther-date ul li.social-sharing-icons{
   margin-left: auto;
   margin-right: 0;
   @media screen and (max-width: 567px){
    margin-left: 0;
    margin-top: 20px;
    width: 100%;
   }
   ul{
    display: flex;
    margin: 0;
    padding: 0;
    list-style: none;
    li{
      margin: 0 5px;
      padding: 0;
      &:last-child{
        margin-right: 0;
      }
      &:first-child{
        @media screen and (max-width: 567px){
          margin-left: 0;
        }
      }

      a{
        display: flex;
        align-items: center;
        justify-content: center;
        width: 30px;
        height: 30px;
        background: #f2f2f2;
        
        i{
          width: auto;
          margin: 0;
          img{
            width: 100%;
            height: 100%;
            display: block;
          }
        }
        &.facebook{
          background: #3b5998;
        }
        &.twitter{
          background: #1DA1F2;
        }
        &.linkedin{
          background: #0077b5;
        }
        &.pinterest{
          background: #E60023;
        }
        &.email{
          background: #575757;
        }
        &:hover{
          opacity: 0.8;
        }
      }
    }
   }
}
</style>